import { ApiProperty } from "@nestjs/swagger";
import { WfxCarharttEnum } from "@project-management-system/shared-models";

export class MeasurementDataDTO {
    @ApiProperty()
    id: number

    @ApiProperty()
    styleId: number

    @ApiProperty()
    measurementData: string
  
    @ApiProperty()
    color: string

    @ApiProperty()
    trimCard: WfxCarharttEnum

    @ApiProperty()
    createdUser: string | null;


}
